import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=c484c6b2&lang=pug&"
import script from "./Live.vue?vue&type=script&lang=ts&"
export * from "./Live.vue?vue&type=script&lang=ts&"
import style0 from "./Live.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports